export default {
  namespaced: true,
  state: {
    entry: [],
    ticket: null,
    count: 0,
  },
  getters: {
    entryTicket(state) {
      const [firstTicket] = state.entry;
      return firstTicket;
    },
    isMorningTime() {
      const now = Date.now();
      const [start, end] = [
        new Date(now).setHours(9, 0, 0),
        new Date(now).setHours(12, 50, 0),
      ];
      return now >= start && now <= end;
    },
    isEveningTime() {
      const now = Date.now();
      const [start, end] = [
        new Date(now).setHours(12, 51, 0),
        new Date(now).setHours(16, 50, 0),
      ];
      return now >= start && now <= end;
    },
    excursions(state, getters) {
      let availableTimes = [];
      if (getters.isMorningTime) {
        availableTimes = ['13:00', '17:00'];
      }
      if (getters.isEveningTime) {
        availableTimes = ['17:00'];
      }
      return availableTimes.map((time) => ({
        name: time,
        price: getters.entryTicket?.price || 0,
        payName: getters.entryTicket?.payName || '',
        type: 'excursion',
        isMorningTime: time === '13:00',
        isEveningTime: time === '17:00',
      }));
    },
    list(state) {
      if (!state.ticket) return [];
      return new Array(state.count).fill(state.ticket);
    },
    sum(state, getters) {
      return getters.list.reduce((total, ticket) => (total + (ticket.price || 0)), 0);
    },
  },
  mutations: {
    setEntry(state, entry) {
      state.entry = entry;
    },
    setTicket(state, ticket) {
      state.ticket = ticket;
    },
    setCount(state, count) {
      state.count = count;
    },
    clearEntry(state) {
      state.entry = [];
    },
    clearTicket(state) {
      state.ticket = null;
    },
    clearCount(state) {
      state.count = 0;
    },
  },
  actions: {
    clearAll({ commit }) {
      commit('clearEntry');
      commit('clearTicket');
      commit('clearCount');
    },
    fetchTickets({ commit }) {
      return this.$axios.get('/m/stock/list')
        .then(({ data }) => {
          const tickets = Object.values(data || {})
            .map((el) => ({ ...el, name: 'Стандартный', payName: el.name }));
          commit('setEntry', tickets);
        });
    },
    confirmPayment(ctx, { count, name }) {
      return this.$axios.post('/m/stock/register_sale', {
        offer_name: name,
        count,
      })
        .then(({ data }) => {
          const badCode = (data || []).find((el) => el.barcode_number === '-1');
          if (badCode) {
            throw new Error(badCode.error_text);
          }
        });
    },
  },
};
